// @ts-check
export const NEW_REFERRAL_BUTTON_CLICKED = 'NEW_REFERRAL_BUTTON_CLICKED';

export function newReferralButtonClicked() {
  return {
    type: NEW_REFERRAL_BUTTON_CLICKED,
  };
}
